import {TreeViewItem} from '../@types/tree-view-item';
import {getPathToRootAsArrayOfString, role} from './group-utils';
import {BreadCrumbsProp} from '../@types/bread-crumb';
import {getResourceNameWithAscendants} from './resource-utils';
import {ResourceType} from '../@types/resource-type';
import NewOccurrenceReport from '../@types/new-occurrence-report';



export function newOccurrenceTreeItems(occurrences: NewOccurrenceReport[]): TreeViewItem[] {
    return occurrences.map((oc: NewOccurrenceReport) => occurrenceTreeItem(oc, role(oc.group),
        getResourceNameWithAscendants(oc.group, ResourceType.GROUPS)))
}

const occurrenceTreeItem = (occurrence: NewOccurrenceReport, role: string, path: string): TreeViewItem => {
    return {
        id: occurrence.id!.toString(),
        object: occurrence,
        name: `${occurrence.uniqueId}`,
        location: occurrence.content.location,
        dateTime: occurrence.dateTime,
        groupPath: path,
        groupRole: role,
        type: ResourceType.NEW_OCCURRENCE_REPORTS,
        hasChildren: false,
        sortField: occurrence.dateTime
    };
}


export function getNewOccurrencePathToRootAsArrayOfString(occurrence: NewOccurrenceReport): Array<BreadCrumbsProp> {
    let path: Array<BreadCrumbsProp> = [];
    if (occurrence.id) {
        path = getPathToRootAsArrayOfString(occurrence.group);
    }

    return [...path, {
        id: occurrence.id,
        label: occurrence.uniqueId,
        type: ResourceType.NEW_OCCURRENCE_REPORTS}];
}
